// react
import React, { useState, useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import ReactTable from "react-table";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Edit from "@material-ui/icons/Edit";
import Equalizer from "@material-ui/icons/Equalizer";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import { GerenciaAlertIniciar } from "beaktShared/views/Crud/AlertInicializar";
import { GerenciaAlertEncerrar } from "beaktShared/views/Crud/AlertEncerrar";
import { GerenciaAlertDesistir } from "beaktShared/views/Crud/AlertDesistir";
import RegistrarContatoList from './Componentes/RegistrarContatoList';
import GestaoCampanhaForm from '../Campanhas/GestaoCampanhaForm';
import ResultadoCampanha from './Componentes/ResultadoCampanha';

// services
import {formateDate} from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function AcompanhamentoCampanha() {
  const { t } = useTranslation();

  const session = useContext(SessionContext);
  const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });
  const classes = useStyles();
  const endPoint = "campanhas/";

  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };

  const SituacaoCampanha = [
    { id: 0, title: 'Todos' },
    { id: 1, title: 'Não Iniciada' },
    { id: 2, title: 'Em Andamento' },
    { id: 3, title: 'Vencida' },
    { id: 4, title: 'Concluída' },
    { id: 5, title: 'Descontinuada' }
  ];

  //selecionar situação das campanhas
  const [situacaoCampanha, setsituacaoCampanha] = React.useState(0);
  const handleSituacaoCampanha = (value) => {
    setsituacaoCampanha(value);
  };

  //lista campanhas
  const [isLoadingListCampanha, setisLoadingListCampanha] = React.useState(false);
  const [listCampanhas, setlistCampanhas] = React.useState([]);

  const handleClickPesquisa = () => {
    const endPointGet = endPoint + "campanhasbysituacao/" + situacaoCampanha + "/" + session.estabelecimentoId;

    setisLoadingListCampanha(true);
    UseGetApiSimple(endPointGet, 0).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'error')
        setisLoadingListCampanha(false);
        setlistCampanhas([]);
        return false;
      }
      if (result.data.length > 0) {
        setisLoadingListCampanha(false);
        let campanhaslist = [];
        result.data.map(obj => {
          campanhaslist.push({
            campanhaId: obj.campanhaId,
            nome: obj.nome,
            tipo: obj.tipoCampanha == 1 ? "Aniversariante" : obj.tipoCampanha == 2 ? "Pacote" : obj.tipoCampanha == 3 ? "Servico" :
              obj.tipoCampanha == 4 ? "Cortesia" : obj.tipoCampanha == 5 ? "CanalMidia" : obj.tipoCampanha ? "Profissao" : "",
            vigenciaDe: obj.vigenciaDe,
            vigenciaAte: obj.vigenciaAte,
            situacao: obj.situacao == 1 ? "Não Iniciada" : obj.situacao == 2 ? "Em Andamento" :
              obj.situacao == 3 ? "Vencida" : obj.situacao == 4 ? "Concluída" :
                obj.situacao == 5 ? "Descontinuada" : ""
          })
        });

        setlistCampanhas(campanhaslist);
      }

      return true;
    });
  };
  //=====================================||========================================================
  //AÇÕES:

  //Detalhes campanha
  const [itemcampanha, setitemcampanha] = React.useState(null);
  const handleDetail = row => {
    let endPointGetCampanha = endPoint + "campanhabyid/" + row.campanhaId;

    UseGetApiSimple(endPointGetCampanha, 0).then(result => {
      if (result.status !== 200) {
        handleView(false);
        return false;
      }
      setitemcampanha(result.data);
      handleView();
      return true;
    });

  };

  const [showFormViewDetail, setshowFormViewDetail] = React.useState(false);
  const handleView = () => {

    let show = showFormViewDetail === true ? false : true;
    setshowFormViewDetail(show);
  };

  //=====================================||========================================================

  //INICIAR CAMPANHA
  const [detailModal, setConfModal] = GerenciaModal();
  const [alertIniciar, setAlertIniciar] = GerenciaAlertIniciar();
  const showAlertInicialize = id => {
    setAlertIniciar({
      statusAlert: 1,
      idToInicializeRecieve: id
    });
  }
  useEffect(() => {
    if (alertIniciar.isToInicialize)
      handleIniciar(alertIniciar.idToInicializeSend);
    // eslint-disable-next-line     
  }, [alertIniciar]);

  const handleIniciar = id => {
    let situacaodto = {
      usuarioId: session.id,
      situacaoId: 2
    }

    let endpointPut = endPoint + "altersituationcampanha/"
    UsePutApi(endpointPut, id.campanhaId, situacaodto).then(result => {
      if (result.status !== 200) {
        showNotification(result.message.message, 'danger');
        return false;
      }
      setAlertIniciar({ statusAlert: 3 });
      handleClickPesquisa();
      return true;
    });

  };
  //=====================================||========================================================

  //ENCERRAR CAMPANHA
  const [alertClose, setAlertClose] = GerenciaAlertEncerrar();
  const showAlertClose = id => {
    setAlertClose({
      statusAlert: 1,
      idToCloseRecieve: id
    });
  }
  useEffect(() => {
    if (alertClose.isToClose)
      handleEncerrar(alertClose.idToCloseSend);
    // eslint-disable-next-line     
  }, [alertClose]);

  const handleEncerrar = id => {
    let situacaodto = {
      usuarioId: session.id,
      situacaoId: 4
    }

    let endpointPut = endPoint + "altersituationcampanha/"
    UsePutApi(endpointPut, id.campanhaId, situacaodto).then(result => {
      if (result.status !== 200) {
        showNotification(result.message.message, 'danger');
        return false;
      }
      setAlertClose({ statusAlert: 3 });
      handleClickPesquisa();
      return true;
    });
  };
  //=====================================||========================================================

  //Desistir CAMPANHA
  const [alertGiveUp, setAlertGiveUp] = GerenciaAlertDesistir();
  const showAlertGiveUp = id => {
    setAlertGiveUp({
      statusAlert: 1,
      idToGiveUpRecieve: id
    });
  }
  useEffect(() => {
    if (alertGiveUp.isToGiveUp)
      handleDesistir(alertGiveUp.idToGiveUpSend);
    // eslint-disable-next-line     
  }, [alertGiveUp]);

  const handleDesistir = id => {

    let situacaodto = {
      usuarioId: session.id,
      situacaoId: 5
    }

    let endpointPut = endPoint + "altersituationcampanha/"
    UsePutApi(endpointPut, id.campanhaId, situacaodto).then(result => {
      if (result.status !== 200) {
        showNotification(result.message.message, 'danger');
        return false;
      }
      setAlertGiveUp({ statusAlert: 3 });
      handleClickPesquisa();
      return true;
    });

  };
  //=====================================||========================================================
  const [btnRegistroContato, setbtnRegistroContato] = React.useState(false);

  //Registrar Contatos
  const handleRegistrarContato = id => {
    let endPointGetCampanha = endPoint + "clientescontatobycampanha/" + id.campanhaId;

    UseGetApiSimple(endPointGetCampanha, 0).then(result => {
      if (result.status !== 200) {
        handleViewContato(false);
        return false;
      }
      setbtnRegistroContato(true);
      setitemcampanha(result.data);
      handleViewContato(false);
      return true;
    });
  }

  const [showFormViewContato, setshowFormViewContato] = React.useState(false);
  const handleViewContato = () => {
    let show = showFormViewContato === true ? false : true;
    setshowFormViewContato(show);
  };
  //=====================================||========================================================

  //Resultado
  const handleResultadoCampanha = id => {
    let endPointGetResultado = endPoint + "resultadocampanha/" + id.campanhaId;

    UseGetApiSimple(endPointGetResultado, 0).then(result => {
      if (result.status !== 200) {
        handleViewResultado(false);
        return false;
      }
      setitemcampanha(result.data);
      handleViewResultado();
      return true;
    });
  }
  const [showFormViewResultado, setshowFormViewResultado] = React.useState(false);
  const handleViewResultado = () => {
    let show = showFormViewResultado === true ? false : true;
    setshowFormViewResultado(show);
  };

  //colunas Table e Ações
  const columnsProp = [{
    Header: t('label.name'),
    accessor: "nome",
  },
  {
    Header: t('label.campaign_type'),
    accessor: "tipo",
  },
  {
    Header: t('label.validity_of'),
    accessor: "vigenciaDe",
    Cell: (props) => {
      const custom_date = props.value == null ? "" : formateDate(props.value)
      return <span>{custom_date}</span>
    }
  },
  {
    Header: t('label.validity_until'),
    accessor: "vigenciaAte",
    Cell: (props) => {
      const custom_date = props.value == null ? "" : formateDate(props.value)
      return <span>{custom_date}</span>
    }
  },
  {
    Header: t('label.situation'),
    accessor: "situacao",
  }]

  const columnsAcao = [
    {
      Header: t('label.actions'),
      Cell: row => (
        <div className="actions-right">
          <Button
            justIcon
            round
            simple
            color="info"
            className="info"
            onClick={() => handleDetail(row.original)}
          >
            <Search />
          </Button>
          {row.original.situacao == "Não Iniciada" &&
            <>
              <Button
                simple
                color="success"
                class="btn btn-outline-success btn-sm"
                onClick={() => showAlertInicialize(row.original)}
              >
                <small>{"Iniciar"}</small>
              </Button>{" "}
              <Button
                simple
                color="success"
                class="btn btn-outline-danger btn-sm"
                onClick={() => showAlertGiveUp(row.original)}
              >
                <small>{"Desistir"}</small>
              </Button>
            </>
          }
          {row.original.situacao == "Em Andamento" &&
            <>
              <Button
                justIcon
                round
                simple
                color="success"
                className="edit"
                onClick={() => handleRegistrarContato(row.original)}
              >
                <Tooltip title={t('label.contacts')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                  <Edit />
                </Tooltip>
              </Button>
              <Button
                simple
                color="success"
                class="btn btn-outline-secondary btn-sm"
                onClick={() => showAlertClose(row.original)}
              >
                <small>{"Encerrar"}</small>
              </Button>
            </>
          }
          {(row.original.situacao == "Concluída") &&
            <>
              <Button
                justIcon
                round
                simple
                color="success"
                className="edit"
                onClick={() => handleResultadoCampanha(row.original)}
              >
                <Tooltip title={t('label.result')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                  <Equalizer />
                </Tooltip>
              </Button>
            </>
          }

        </div>
      ),
      sortable: false,
      filterable: false
    }
  ];
  const columns = [...columnsProp, ...columnsAcao]

  return (
    <div>

      <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification({ show: false })}
        close
      />

      {showFormViewDetail && <GestaoCampanhaForm itemcampanha={itemcampanha} handleView={handleView} disableform={true} />}
      {showFormViewContato && <RegistrarContatoList itemcampanha={itemcampanha} handleViewContato={handleViewContato} btnRegistraContato={btnRegistroContato} />}
      {showFormViewResultado && <ResultadoCampanha itemcampanha={itemcampanha} handleViewResultado={handleViewResultado} />}

      {!showFormViewContato && !showFormViewDetail && !showFormViewResultado &&
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t('sidebar.campaign_follow_up')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className="subTitulo">
                      <h6>{t('label.search_campaigns')} </h6>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth className={classes.formControl}>
                      <label className={errors.situacaocampanha ? "select__label select__label_error" : "select__label"}>{t('label.campaigns_situation') + " *"} </label>
                      <Select
                        classNamePrefix="select"
                        styles={ValidSelect(errors.situacaocampanha ? true : false)}
                        isSearchable={true}
                        name="situacaocampanha"
                        placeholder={t('label.select') + " ..."}
                        options={SituacaoCampanha}
                        value={SituacaoCampanha.filter(({ id }) => id === situacaoCampanha)}
                        getOptionLabel={({ title }) => title}
                        getOptionValue={({ id }) => id}
                        onChange={(value) => handleSituacaoCampanha(value.id)}
                        ref={() => register(
                          { name: "situacaocampanha" })
                        }
                      />
                      <FormHelperText className={classes.labelRootError}>
                        {errors.situacaocampanha && <span>{t('label.required')}</span>}
                      </FormHelperText>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={2}>
                    <Button round color="primary"
                      onClick={e => { handleClickPesquisa() }}>
                      {t('label.search')}
                    </Button>
                  </GridItem>
                </GridContainer>
                {listCampanhas.length > 0 &&
                  <GridContainer>
                    <GridItem xs={12}>
                      <ReactTable
                        loading={isLoadingListCampanha}
                        data={listCampanhas}
                        columns={columns}
                        filterable={false}
                        defaultPageSize={10}
                        minRows={5}
                        showPaginationBottom={true}
                        className="-striped -highlight"
                        previousText={t('button.previous')}
                        nextText={t('button.next')}
                        loadingText={t('label.loading') + "..."}
                        noDataText={t('information_message.no_records_found') + "!"}
                        pageText={t('label.page')}
                        ofText={t('label.of')}
                        rowsText={t('label.rows')}
                      />
                    </GridItem>
                  </GridContainer>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

      }
      {alertIniciar.componente}
      {alertClose.componente}
      {alertGiveUp.componente}
      {detailModal}
    </div>
  );
}
